export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";
export const API_SECRET_KEY = import.meta.env.VITE_API_SECRET ?? "";
